module.exports = "https://r.nearpod.com/assets/media/image/paywall-icon-67a5389812368aa2dba0ec202c23db31.svg";